import Vue from 'vue';
import gsap from 'gsap';

Vue.component('language-component', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            active: false,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {

    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        toggleLanguageSelector() {
            if (!this.active) {
                this.active = true;
            } else {
                this.active = false;
            }
        },

    },
});
